import React from "react";
import {
  ExpandableSection
} from "@cloudscape-design/components";
const ExampleCSV = () => {
  return /* @__PURE__ */ React.createElement(ExpandableSection, { header: "Example CSV" }, /* @__PURE__ */ React.createElement("pre", null, "accountId,accountName,region", /* @__PURE__ */ React.createElement("br", null), "123456789123,example-account-1,eu-west-1,", /* @__PURE__ */ React.createElement("br", null), "123456789123,example-account-1,eu-west-2,", /* @__PURE__ */ React.createElement("br", null), "123456789124,example-account-2,eu-west-1,", /* @__PURE__ */ React.createElement("br", null), "123456789125,example-account-3,eu-west-1,"));
};
export default ExampleCSV;
